import React from "react"
import { StaticQuery, Link, graphql } from "gatsby"
import styles from "./topbar.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default ({ children }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              websiteConfig {
                topbar {
                  social {
                    link
                    type
                    icon
                    color
                    content
                  }
                  email {
                    link
                    icon
                    color
                    content
                  }
                  phone {
                    link
                    icon
                    color
                    content
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        return (
          <div className="row">
            <div className="col-lg-12 p-0">
              <ul
                className="pl-lg-5 pr-lg-5 pl-3 pr-3 d-flex align-items-center justify-content-end"
                style={{ backgroundColor: "#011c1f", height: "32px" }}
              >
                <li className="m-0 mr-2 d-lg-block d-none">
                  <a
                    href={
                      data.site.siteMetadata.websiteConfig.topbar.email.content
                    }
                    style={{ color: "#00bcd4" }}
                  >
                    <FontAwesomeIcon
                      icon={
                        data.site.siteMetadata.websiteConfig.topbar.email.icon
                      }
                    />
                    {data.site.siteMetadata.websiteConfig.topbar.email.content}
                  </a>
                </li>
                <li
                  className="m-0 ml-1 mr-2 d-lg-block d-none"
                  style={{ color: "#00bcd4" }}
                >
                  |
                </li>
                <li className="m-0 mr-2 d-lg-block d-none">
                  <a
                    style={{ color: "#00bcd4" }}
                    href={
                      data.site.siteMetadata.websiteConfig.topbar.phone.content
                    }
                  >
                    <FontAwesomeIcon
                      icon={
                        data.site.siteMetadata.websiteConfig.topbar.phone.icon
                      }
                    />
                    {data.site.siteMetadata.websiteConfig.topbar.phone.content}
                  </a>
                </li>
                <li
                  className="m-0 ml-1 mr-2 d-lg-block d-none"
                  style={{ color: "#00bcd4" }}
                >
                  |
                </li>
                {data.site.siteMetadata.websiteConfig.topbar.social.map(
                  social => {
                    return (
                      <li key={social.type} className="m-0 mr-1">
                        <a href={social.link} style={{ color: "#00bcd4" }}>
                          <FontAwesomeIcon icon={["fab", social.icon]} />
                        </a>
                      </li>
                    )
                  }
                )}
              </ul>
            </div>
          </div>
        )
      }}
    />
  )
}
